import { Tag } from '@webmotors/eleanor-ui';
import type { TStatusId } from '../../../../utils';
import { STATUS_CONFIG } from '../../../../utils';
import { myAdsTestId } from '../../../../utils';
import { cardStatusTagStyles } from './card-status-tag.styles';
import type { TCardStatusTagConfig } from '../../vehicle-card.types';

type TagVariant = 'inactive' | 'warning' | 'success' | 'informative' | 'critical';

const STATUS_TO_TAG_VARIANT: Record<TStatusId, TagVariant> = {
	active: 'success',
	pending: 'informative',
	inactive: 'inactive',
	unavailable: 'critical',
	transaction_failed: 'warning',
	ios_payment_only: 'informative',
	incomplete: 'warning',
	payment_pending: 'warning',
	payment_unauthorized: 'critical'
};

const CardStatusTag = ({ adId, status }: TCardStatusTagConfig) => {
	const config = STATUS_CONFIG[status];
	const variant = STATUS_TO_TAG_VARIANT[status];

	return (
		<span className={cardStatusTagStyles.wrapper} data-testid={myAdsTestId.cardStatus(adId)}>
			<Tag variant={variant} content={config.label} />
		</span>
	);
};

CardStatusTag.displayName = 'CardStatusTag';

export { CardStatusTag };
